import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { OriginalityService } from 'src/app/+app-custom/services/originality.service';
import { first } from 'rxjs/operators';
import { PromocodeModel } from '../../../../models/promocode/promocode.model';
import { copyTextToClipboard } from '../../../../misc/copy-text-to-clipboard';
import {
  createSubQueryFromObject,
  getEmptyQueryDesigner,
} from '../../../../../core-frontend-common/misc/query-designer/query-designer-functions';
import {
  QueryDesignerOrderBy,
  QueryDesignerSearch,
  QueryDesignerSubWhere,
  QueryDesignerWhere,
  queryFilterTypes,
  queryOperators,
  queryResultOrder,
} from '../../../../../core-frontend-common/misc/query-designer/query-designer';
import { MessageService } from 'primeng';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'smart-list-promocodes',
  templateUrl: './list-promocodes.component.html',
  styleUrls: ['./list-promocodes.component.scss'],
})
export class ListPromocodesComponent implements OnInit {

  promocodeFilterTypes = {
    all: 'all',
    used: 'used',
    notused: 'notused',
  };

  promocodeTypes = [
    {
      name: 'all',
      value: null,
    },
    {
      name: 'paymentPromocode',
      value: 'cash',
    },
    {
      name: 'schoolPromocode',
      value: 'public',
    },
    {
      name: 'userPromocode',
      value: 'private',
    },
  ];

  currentFilter = {
    type: this.promocodeFilterTypes.all,
    promocodeType: null,
    search: '',
  };

  tableData = {
    totalItems: 0,
    page: 1,
    pageSize: 25,
    loading: false,
  };

  isSubsection = false;

  promocodes: PromocodeModel[] = [];

  @Input() set setPromocodeType(type: string) {
    this.currentFilter.promocodeType = type !== 'all' ? type : null;

    this.isSubsection = type !== 'all';

    if (!this.tableData.loading) {
      this.submitFilter();
    }
  }

  constructor(
    private originalityService: OriginalityService,
    private messageService: MessageService,
    private confirmService: ConfirmationService
  ) {
  }

  ngOnInit() {
  }

  copyPromocode(promocode: string) {
    copyTextToClipboard(promocode);
  }

  onPromocodeTypeFilterChange(promocodeType) {
    this.currentFilter.promocodeType = promocodeType.value.value;
  }

  setPage(pageInfo) {
    if (!pageInfo) {
      return;
    }
    this.tableData.page = (pageInfo.first + pageInfo.rows) / this.tableData.pageSize;

    this.submitFilter();
  }

  resetFilter() {
    this.currentFilter = {
      type: this.promocodeFilterTypes.all,
      promocodeType: this.isSubsection ? this.currentFilter.promocodeType : null,
      search: '',
    };

    this.tableData.page = 1;

    this.submitFilter();
  }

  submitFilter() {
    const query = getEmptyQueryDesigner();

    const where = new QueryDesignerWhere();
    where.operatorType = queryOperators.AND;

    const order = new QueryDesignerOrderBy('createdDatetime', queryResultOrder.DESC);
    query.orderBy = [order];

    if (this.currentFilter.search && this.currentFilter.search.length > 0) {
      const search = new QueryDesignerSearch().createEmpty();
      search.value = this.currentFilter.search;
      search.fields = ['userEmail', 'code'];
      // @ts-ignore
      query.search = search;
    } else {
      delete query.search;
    }

    if (this.currentFilter.promocodeType) {
      const type = createSubQueryFromObject(queryOperators.OR, this.currentFilter.promocodeType, 'type', queryFilterTypes.EQUAL);
      const subwhere = new QueryDesignerSubWhere();
      subwhere.operatorType = queryOperators.OR;
      subwhere.operands = [type];
      where.operands.push(subwhere);
    }

    if (this.currentFilter.type) {
      let type;

      switch (this.currentFilter.type) {
        case 'all':
          break;
        case this.promocodeFilterTypes.used:
          type = createSubQueryFromObject(queryOperators.OR, {}, 'usedDatetime', queryFilterTypes.IsNotNull);
          break;
        case this.promocodeFilterTypes.notused:
          type = createSubQueryFromObject(queryOperators.OR, {}, 'usedDatetime', queryFilterTypes.IsNull);
          break;
      }

      if (type) {
        const subwhere = new QueryDesignerSubWhere();
        subwhere.operatorType = queryOperators.OR;
        subwhere.operands = [type];
        where.operands.push(subwhere);
      }
    }

    query.where = where;
    query.pageSize = this.tableData.pageSize;
    query.page = this.tableData.page;

    console.log(this.currentFilter);
    this.loadData(query);
  }

  async loadData(filter) {
    this.tableData.loading = true;

    this.originalityService
      .getAllPromocodesByFilter(filter)
      .pipe(first())
      .subscribe({
        next: value => {
          this.promocodes = value.items;
          this.tableData.totalItems = value.totalItems;
          this.tableData.loading = false;
          console.log(value);
        },
        error: err => {
          this.tableData.loading = false;
          this.promocodes = [];
          console.log(err);
        },
      });
  }

  async deletePromocode(promocodeModel: PromocodeModel) {

    this.confirmService
      .confirm({
        message: `Skutočne si prajete zmazať promokód ${promocodeModel.code} zo systému?`,
        acceptLabel: 'Zmazať',
        rejectLabel: 'Zrušiť',
        accept: () => {
          this.originalityService
            .deletePromocode(promocodeModel.id)
            .pipe(first())
            .subscribe(() => {
              this.messageService.add({severity: 'success', summary: 'Promokód bol úspešne zmazaný.'});
              this.submitFilter();
            }, () => {
              this.messageService.add({severity: 'error', summary: 'Promokód sa zmazať nepodarilo.'});
            });
        }
      });

  }

}
